import { render, staticRenderFns } from "./certification-levels-modal.vue?vue&type=template&id=deab5478"
import script from "./certification-levels-modal.vue?vue&type=script&lang=js"
export * from "./certification-levels-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports